<module-container>
  <div class="title-container">
    <h2>User Pool Group Config</h2>
  </div>
  <abcis-table [configuration]="tableConfig"></abcis-table>
</module-container>
